import { UITablePagination } from "./guiElements";

export const Languages = {
    selectedLanguage: "it",
    getSection(section) {
        try {
            return Languages[section][Languages.selectedLanguage];
        }
        catch (e) {
            return {};
        }
    },
    Main: {
        it: {
            summary: { row1: 'Totali', row2: 'Oggi' },
            searchLabel: 'Cerca',
            refreshLabel: 'Aggiorna',
            filterBy: 'Filtra per:',
            menuLabels: {
                howToSendapro: 'How To SendaPro',
                mySendapro: 'My SendaPro',

                solutions: 'Soluzioni',
                orders: 'Ordini',
                ordersCreate: 'Crea Ordine',
                ordersCreateSingle: 'Crea Ordine singolo',
                ordersList: 'Lista ordini',
                ordersListDiscarded: 'Lista ordini scartati',
                ordersBordero: 'Borderò',
                ordersHistory: 'Storico',
                ordersReturned: 'Resi',
                orderCredits: 'Gestione crediti',
                trackAndTrace: 'Track & Trace',
                countersigns: 'Contrassegni',
                stockHandling: 'Giacenze',

                warehouse: 'Magazzino',
                warehouseOrders: 'Ordini',
                warehouseordersCreateSingle: 'Crea ordine',
                warehouseOrdersHistory: 'Storico ordini',
                products: 'Prodotti',
                registryProduct: 'Registra Prodotti',
                returnProducts: 'Visualizza Prodotti',
                stock: 'Stock',
                forecasts: 'Previsionali',

                connections: 'Connessioni',
                couriers: 'Corrieri',
                marketplaces: 'Marketplaces',

                settings: 'Impostazioni',
                company: 'Società',
                addresses: 'Indirizzi',
                senderAddressses: "Indirizzi Mittente",
                recipientAddresses: "Indirizzi Destinatario",
                package: 'Anagrafica Colli',
                labels: 'Etichette',
                notifications: 'Comunicazione',

                profile: 'Profilo',
                user: 'Utente',
                myProfile: 'Il mio profilo'
            },

            menuSections: {
                s1: {
                    title: 'soluzioni',
                    i1: {
                        title: 'Ordini',
                        si1: 'Crea Ordine',
                        si2: 'Crea Ordine singolo',
                        si3: 'Lista ordini',
                        si4: 'Lista ordini scartati',
                        si5: 'Borderò',
                        si6: 'Storico',
                        si7: 'Resi',
                        si8: 'Gestione crediti'
                    },
                    i2: { title: 'Track & Trace' },
                    i3: { title: 'Contrassegni' },
                    i4: { title: 'Gestione Giacenze' }
                },
                s2: {
                    title: 'connessioni',
                    i1: { title: 'Corrieri' },
                    i2: { title: 'Marketplaces' }
                },
                s3: {
                    title: 'impostazioni',
                    i1: {
                        title: 'Impostazioni',
                        si1: 'Società',
                        si2: 'Indirizzi',
                        si3: 'Collo',
                        si4: 'Etichette',
                    },
                    i2: { title: 'Comunicazione' }
                },
                s4: {
                    title: 'profilo',
                    i1: {
                        title: 'User',
                        si1: 'Il mio profilo',
                        si2: 'Logout'
                    }
                },
                s5: {
                    title: 'warehouse',
                    i1: {
                        title: 'Ordini',
                        si1: 'Crea Ordine',
                        si2: 'Crea Ordine singolo',
                        si3: 'Lista ordini',
                        si4: 'Lista ordini scartati',
                        si6: 'Storico',
                    },
                    i2: {
                        title: 'Prodotti',
                        si1: 'Registra Prodotti',
                        si2: 'Ricerca Prodotti',
                    },
                    i3: { title: 'Stpcl' },
                    i4: { title: 'Previsionali' }
                },
            },
            messages: {
                fileNotFound: { captions: ["errore"], messages: ['File non trovato'], button: "Ok" },
                msgError: {
                    title: "errore",
                    messages: ["Si e' verificato un errore"],
                    buttons: ["Ok"]
                },
                msgSetProfile: {
                    captions: [
                        "Completa la registrazione inserendo dati di fatturazione",
                        "Inizia creandone uno per i tuoi acquisti e transazioni"
                    ],
                    messages: [
                        "Prima di cominciare l'acquisto e la creazione di una spedizione crea un profilo di ADMIN così da poter gestire più agevolmente i tuoi movimenti e le tue transazioni.",
                        "Ti consigliamo di creare in quest'ordine: il tuo profilo, la tua rete di corrieri e di associare tutti i tuoi marketplace.",
                        "",
                        "Per una esperienza di navigazione senza problemi."
                    ],
                    buttons: {
                        ok: { text: "crea profilo" }
                    }
                },
                msgAcceptance: {
                    title: "accettazione trattamento dati personali",
                    messages: ["Premendo il tasto OK si accetta la modalità del trattamento dei dati personali effettuata dal sito."],
                    buttons: { ok: "Ok", cancel: "annulla" }
                },
                loader: {
                    messages: ["Esecuzione in corso...", "Caricamento...", "Download informazioni..."]
                }
            },
            buttons: { modify: 'Modifica', delete: 'Elimina', cancel: 'Annulla' },
            faqButtonUrl: "https://www.sendabox.it/Support.cshtml",
            navigation: ['righe per pagina']
        }
    },
    Login: {
        it: {
            caption: ['Esegui il login:', 'ACCEDI'],
            email: 'email',
            password: 'password',
            message: 'Inviando questo modulo, accetti la nostra politca sulla privacy e tutti gli usi dei tuoi dati personali ivi indicati',
            button: 'login',
            messages: [{
                captions: ["errore in fase di autenticazione"],
                messages: [],
                buttons: ["Ok"]
            }],
            forgotPassword: "Password dimenticata?"
        }
    },
    PasswordRecovery: {
        it: {
            common: {
                backToLogin: "Torna al login",
                invalidLink: "Il collegamento non è valido o è scaduto."
            },
            request: {
                title: "Recupero password",
                successTitle: "Richiesta inviata",
                usernamePlaceholder: "username",
                instructions: "Inserisci il tuo username per ricevere l'email di recupero password.",
                submit: "INVIA EMAIL",
                requiredError: "Inserisci lo username.",
                requestError: "Impossibile inviare la richiesta. Riprova.",
                genericResult: "Se l'account è attivo e configurato per il recupero, riceverai un'email con le istruzioni."
            },
            reset: {
                title: "Nuova password",
                successTitle: "Password modificata",
                passwordPlaceholder: "Nuova password",
                confirmPasswordPlaceholder: "Conferma nuova password",
                submit: "Cambia password",
                requirementsError: "La password non rispetta i requisiti.",
                mismatchError: "Le password non coincidono.",
                success: "Password modificata. Ora puoi accedere.",
                invalidOrExpired: "Non è stato possibile modificare la password. Verifica che rispetti i requisiti, che sia diversa dalla password attuale e che il collegamento sia ancora valido."
            },
            verification: {
                title: "Verifica email di recupero",
                loading: "Verifica dell'email di recupero in corso...",
                success: "Email di recupero verificata correttamente."
            }
        }
    },
    MySendaPro: {
        it: {
            r1: {
                title: 'Ordini effettuati',
                months: {
                    1: 'Gen',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Mag',
                    6: 'Giu',
                    7: 'Lug',
                    8: 'Ago',
                    9: 'Set',
                    10: 'Ott',
                    11: 'Nov',
                    12: 'Dic'
                }
            },
            r2: {
                caption1: 'Clienti',
                caption2: 'Giacenze',
                caption3: 'Ordini Nazionali',
                caption4: 'Ordini Internazionali',
                caption5: 'unused',
                caption6: 'I tuoi Marketplace attivi',
                caption7: 'I tuoi Corrieri attivi',
                caption8: 'Contrassegni',
                today: 'Oggi',
                shortcuts: {
                    title: 'Funzioni più utilizzate',
                    links: [{ text: 'Crea ordine singolo', url: '/orders-2' }, { text: 'Track & trace', url: '/tracking-0' }, { text: 'Borderò', url: '/orders-5' },]
                }
            },
            favoriteWidgets: {
                title: "Le tue funzioni preferite",
                popupTitle: "Scegli i tuoi widget preferiti",
                trackAndTrace: {
                    title: "Track & Trace",
                    downloadCSV: "Scarica CSV",
                    linkText: "Track & Trace"
                },
                toBeSendToCorier: {
                    title: "Da inviare al corriere",
                    total: "Totali",
                    linkText: "Lista Ordini"
                },
                stocks: {
                    title: "Giacenze",
                    total: "Totali",
                    linkText: "Gestione Giacenze"
                },
                countersign: {
                    title: "Contrassegni",
                    total: "Totali",
                    linkText: "Contrassegni"
                },
                ordersList: {
                    title: "Lista Ordini",
                    total: "Totali",
                    linkText: "Lista Ordini"
                },
                orders: {
                    title: "Ordini",
                    createOrder: "Crea ordine",
                    createSingleOrder: "Crea ordine singolo"
                }
            },
            r3: {
                title: 'panoramica',
                ph1: 'Nome prodotto',
                ph2: 'Prezzo',
                ph3: 'Venduti'
            }
        }
    },
    HowToSendaPro: {
        it: {
            welcome: 'Benvenuto',
            intro1: 'Inizia ad utilizzare SendaPRO',
            intro2: 'ecco qui i primi step per iniziare.',
            video: {
                title: 'Video introduttivo',
                url: '../images/Sendapro_v.3.3.mp4'
            },
            faq: {
                title: 'Domande frequenti',
                link1: 'Cos’è Sendapro?',
                desc1: 'SendaPro è la piattaforma per gestire e semplificare  le spedizioni del tuo e-commerce.',
                url1: '',
                link2: 'Come funziona Sendapro?',
                desc2: 'Crea le etichette,  traccia le spedizioni, gestisci i resi dei tuoi ordini tutto in un’unica piattaforma.',
                url2: '',
                link3: 'Posso connettere i miei corrieri e canali di vendita?',
                desc3: 'SendaPro integra ottimamente  tutti i corrieri  e le piattaforme  e-commerce  più diffuse.',
                url3: '',
                foot1: 'Leggi tutte le ',
                foot2: 'FAQ',
                url4: 'https://www.sendabox.it/FAQ.cshtml',
            },
            fatturazione: {
                title: 'Fatturazione Elettronica',
                desc: 'Ai fini della fatturazione elettronica, ricordati di inserire codice unico e indirizzo PEC.'
            },
            api: {
                title: 'Collega i marketplace',
                desc1: 'Ecco qui una semplice guida per aiutarti con l’integrazione di SendaPro API.',
                desc2: 'Le API multi- corriere di SendaPro permettono agli sviluppatori di realizzare applicazioni che si interfacciano con la Piattaforma SendaPro.',
                btn: 'Aggiungi i tuoi store',
            },
            shipping: {
                title: 'La prima spedizione',
                desc1: 'Potrai facilmente procedere nella spedizione del tuoi primi prodotti caricando le spedizioni da un file, dal tuo Canale di Vendita o creandole manualmente.',
                desc2: '',
                btn: 'Spedisci il tuo primo ordine'

            },
            courier: {
                title: 'Traccia le spedizioni',
                desc1: 'Monitora lo stato della tua spedizione 24 ore su 24 grazie al servizio di tracking online nella sezione Track&Trace.',
                desc2: '',
                btn: 'Controlla le tue spedizioni'
            }
        }
    },
    OrderCreation: {
        it: {
            addressNormTitle: 'Gestione indirizzo',
            addressNorm: 'Normalizzato',
            addressOrig: 'Originale',
            addressNormModal: {
                confirm: 'Conferma',
                title: 'Verifica indirizzo',
                ko: 'cap/localita\' non trovati:verificare correttezza indirizzo',
                ok: 'indirizzo ok',
                verify: 'cap/localita normalizzati da SendaPRO: verificare'
            },
            address: {
                name: 'nome/ragione sociale',
                surname: 'cognome',
                address: 'indirizzo',
                addressNum: 'numero civico',
                city: 'città',
                province: 'provincia',
                zip: 'cap',
                number: 'telefono',
                email: 'email',
                note: 'note'
            },
            triangulation: {
                name: 'nome',
                surname: 'cognome',
                address: 'indirizzo',
                addressNum: 'numero civico',
                country: 'nazione',
                city: 'città',
                province: 'provincia',
                zip: 'cap',
                number: 'telefono',
            },
            creation: {
                title: "crea ordine",
                transferTitle: "Template ordini",
                marketplaceTitle: "I tuoi Marketplace attivi",
                csv: ["carica csv", "scarica layout csv", "scarica istruzioni"]
            },
            filters: {
                title: 'filtri',
                items: {
                    marketplace: "Marketplace",
                    vector: "Vettore",
                    orderNum: "Numero ordine",
                    dateFrom: "Data Da",
                    dateTo: "Data A",
                    addressYellowAlert: 'Indirizzo giallo',
                    addressRedAlert: 'Indirizzo rosso'
                },
                button: "filtra",
            },
            list: ["Magazzino", "Data", "Numero Ordine", "Vettore", "Marketplace", "Servizi aggiuntivi", "Azione", "Pronto", "Stato indirizzo", "Costo corriere", "   "],
            listButton: 'Gestisci Ordine',
            button: 'Crea ordine',
            buttonCost: 'Costo corriere',
            buttonAll: 'Crea tutto',
            deleteOrder: 'Elimina',
            deleteAllOrder: 'Elimina tutto',
            buttonRefresh: 'refresh',
            buttonManage: 'Gestisci Ordine Multiplo',
            manage: {
                title: "Gestisci Ordine",
                titleMultiple: "Gestisci Ordine Multiplo",
                triangulation: {
                    title: 'Triangolazione',
                    inputs: {
                        name: 'nome/ragione sociale',
                        surname: 'cognome',
                        at: 'presso nome o numero',
                        address: 'indirizzo',
                        houseNo: 'numero civico',
                        country: 'nazione',
                        city: 'città',
                        province: 'provincia',
                        zip: 'cap',
                        number: 'numero di cellulare',
                    }
                },
                recipient: {
                    title: 'Destinatario',
                    inputs: {
                        name: 'nome/ragione sociale',
                        surname: 'cognome',
                        at: 'presso nome o numero',
                        address: 'indirizzo',
                        houseNo: 'numero civico',
                        country: 'nazione',
                        city: 'città',
                        province: 'provincia',
                        zip: 'cap',
                        number: 'numero di cellulare',
                        email: 'email',
                        note: 'note consegna'
                    }
                },
                captions: {
                    orderNo: "N° Ordine:",
                    warehouse: "Magazzino:",
                    marketplace: "Marketplace:",
                    customer: "Cliente:",
                    destination: "Destinatario:",
                    sender: "Mittente:"
                },
                package: {
                    titleConf: 'Aggiungi colli',
                    packageConfigTitle: "Colli:",
                    title: 'Pacco',
                    remove: 'Cancella',
                    inputs: ['Lung', 'Alt', 'Prof', 'Peso'],
                    units: ['cm', 'cm', 'cm', 'kg'],
                    properties: ['length', 'height', 'depth', 'weight'],
                    packageOptionDefaultValue: "Seleziona anagrafica collo"
                },
                carrier: {
                    title: "Vettore"
                },
                additionals: {
                    title: 'Servizi aggiuntivi',
                    services: ['Assicurazione', 'Contrassegno', 'Triangolazione'], //'Prenotazione ritiro'
                },
                buttons: { carrier: 'Reimposta Vettore', confirm: 'conferma' }
            },
            message: {
                captions: ["Creazione ordine"],
                messages: [],
                button: "Ok",
                csvUploaded: ["File in elaborazione... ", "Vuoi continuare con la creazione dell'ordine?", " Il presente importo non è comprensivo dei costi relativi ad eventuali Servizi Accessori", "che potranno esservi addebitati in un momento successivo alla conclusione dell’ordine.", "Per la definizione di Servizi Accessori e dei relativi costi,", "si rimanda alle Condizioni Generali di Vendita di Sendabox pubblicate sul nostro sito"],
                marketPlaceUploaded: "Ordini marketplace in elaborazione...",
                error: "Si e' verificato un errore...",
                selectOrders: "Selezionare almeno un ordine.",
                orderLoaded: "L'ordine è stato caricato (Lista ordini).",
                orderCreationError: "Devono essere configurate le dimensioni del collo ('Gestione Ordine') per:",
                noSelectedOrders: "Nessun ordine selezionato.",
                orderLoadingError: "Errore caricamento",
                orderLoadingTitle: "Caricamento ordini",
                orderFailsCsvBtn: "Scarica CSV Errori [*]"
            },
            messages: {

                error: {
                    captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok"
                },
                orderLoaded: {
                    captions: ["info"], messages: ['L\'ordine è stato caricato(Lista ordini).'], button: "Ok"
                },
                noSelectedOrders: {
                    captions: ["info"], messages: ['Nessun ordine selezionato.'], button: "Ok"
                },
                csvUploaded: {
                    captions: ["info"], messages: ['File in elaborazione...', "Vuoi continuare con la creazione dell'ordine?", " Il presente importo non è comprensivo dei costi relativi ad eventuali Servizi Accessori", "che potranno esservi addebitati in un momento successivo alla conclusione dell’ordine.", "Per la definizione di Servizi Accessori e dei relativi costi,", "si rimanda alle Condizioni Generali di Vendita di Sendabox pubblicate sul nostro sito"], button: "Ok"
                },
                marketplaceUploaded: {
                    captions: ["info"], messages: ['Ordini marketplace in elaborazione...'], button: "Ok"
                },
                carrierReset: {
                    captions: ["info"], messages: ['Corriere aggiornato su tutti gli ordini'], button: "Ok"
                },
                euCountry: {
                    captions: ["info"], messages: [
                        'Avvisiamo che per spedire nei Paesi Extra UE è necessario quanto segue.',
                        'Dotarsi di un codice EORI al fine di essere abilitati all’esportazione extra UE. Allegare alla spedizione:',
                        '- lettera di vettura debitamente compilata',
                        '- fattura commerciale o proforma contenente una descrizione dettagliata della merce spedita e la dichiarazione di libera esportazione'], button: "Ok"
                }
                // { captions: ["info"], messages: [
                //     'Avvisiamo che per spedire nei Paesi Extra UE è necessario quanto segue.',
                //     'Dotarsi di un codice EORI al fine di essere abilitati all’esportazione extra UE. Allegare alla spedizione:',
                //     'lettera di vettura debitamente compilata',
                //     'fattura commerciale o proforma contenente una descrizione dettagliata della merce spedita'], button: "Ok" },
            },
            popup: {
                confirmText: "Ok",
                cancelText: "Annulla",
                deleteAllPopup: { title: 'Gestione creazione ordine', message: 'Vuoi eliminare tutti gli ordini?' }
            },
            assuranceModal: {
                captions: ["Termini utilizzo assicurazione"],
                messages: ["Accetto le condizioni"],
                okText: "Accetto",
                cancelText: "Annulla",
                linkText: "Leggi condizioni",
                link: "https://www.sendabox.it/spedizioni-con-assicurazione.cshtml",
            },
            carrierCostModal: {
                captions: ["Costo ordine corriere"],
                messages: ["Disponibili {0} Costo Ordine {1}", "Vuoi continuare con la creazione dell'ordine?", " Il presente importo non è comprensivo dei costi relativi ad eventuali Servizi Accessori", "che potranno esservi addebitati in un momento successivo alla conclusione dell’ordine.", "Per la definizione di Servizi Accessori e dei relativi costi,", "si rimanda alle Condizioni Generali di Vendita di Sendabox pubblicate sul nostro sito"],
                okText: "Accetto",
                cancelText: "Annulla",

            }
        }
    },
    SingleOrderCreation: {
        it: {
            title: "Crea ordine singolo",
            configuration: "Configurazione",
            packageConfigTitle: "Configurazione Colli",
            courier: 'Corriere',
            orderNumLabel: 'Numero ordine',
            orderContentValueLabel: 'Valore merce',
            orderContentDescLabel: 'Contenuto',
            orderContentDescCheckLabel: 'Non sto spendendo articoli proibiti e sto utilizzando un imballaggio adeguato',
            package: {
                addPackage: 'aggiungi colli',
                removePackage: 'cancella',
                title: 'pacco',
                inputs: ['peso', 'lunghezza', 'altezza', 'profondità'],
                units: ['Kg:', 'Cm:', 'Cm:', 'Cm:'],
                packageOptionDefaultValue: "Seleziona anagrafica collo"
            },
            services: {
                title: 'Servizi aggiuntivi',
                service: [
                    { title: 'assicurazione', text: 'valore assicurato' },
                    { title: 'contrassegno', text: 'valore assicurato' },
                    { title: 'triangolazione', text: 'triangolazione' },
                    // { title: 'data di ritiro', text: 'scegli una data per il ritiro' }
                ]
            },
            acceptance: 'Accetto le condizioni',
            acceptanceLink: {
                link: 'https://www.sendabox.it/spedizioni-con-assicurazione.cshtml',
                text: '(Leggi condizioni)'
            },
            triangulation: {
                title: 'Triangolazione',
                inputs: ['nome', 'cognome', 'presso nome o numero', 'indirizzo', 'numero civico', "nazione", 'città', 'provincia', 'cap', 'numero di cellulare', 'email', 'conferma email', 'note consegna']
            },
            sender: {
                title: 'Mittente',
                warehouse: 'magazzino',
                inputs: ['nome', 'cognome', 'presso nome o numero', 'indirizzo', 'numero civico', 'città', 'provincia', 'cap', 'numero di cellulare', 'email', 'note ritiro']
            },
            recipient: {
                title: 'Destinatario',
                warehouse: 'Destinatario',
                inputs: ['nome', 'cognome', 'presso nome o numero', 'indirizzo', 'numero civico', "nazione", 'città', 'provincia', 'cap', 'numero di cellulare', 'email', 'note consegna']
            },
            button: 'Crea ordine',
            warehouses: {
                word: 'magazzino',
                title: 'scegli magazzino per il pickup',
                button: 'seleziona magazzino'
            },
            carrierCostModal: {
                captions: ["Costo ordine corriere"],
                message: ["Disponibili {0} Costo Ordine {1}.", "Vuoi continuare con la creazione dell'ordine?", " Il presente importo non è comprensivo dei costi relativi ad eventuali Servizi Accessori", "che potranno esservi addebitati in un momento successivo alla conclusione dell’ordine.", "Per la definizione di Servizi Accessori e dei relativi costi,", "si rimanda alle Condizioni Generali di Vendita di Sendabox pubblicate sul nostro sito"],
                okText: "Accetto",
                cancelText: "Annulla",

            },
            messages: [
                { captions: ["errore"], messages: ['Si e\' verificato un errore'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" },
                { captions: ["errore"], messages: ['Compilare correttamente i campi evidenziati'], button: "Ok" },
                {
                    captions: ["info"], messages: [
                        'Avvisiamo che per spedire nei Paesi Extra UE è necessario quanto segue.',
                        'Dotarsi di un codice EORI al fine di essere abilitati all’esportazione extra UE. Allegare alla spedizione:',
                        '- lettera di vettura debitamente compilata',
                        '- fattura commerciale o proforma contenente una descrizione dettagliata della merce spedita e la dichiarazione di libera esportazione'], button: "Ok"
                },
            ]
        }
    },
    OrderHistory: {
        it: {
            title: 'storico',
            list: ["Numero Ordine", "Data", "Vettore", "Cliente", "Servizi Aggiuntivi", "Azioni", "Seleziona tutto"],
            listButtons: ['Scarica etichette', 'Reso', 'Elimina'],
            messages: [
                { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
            ],
            popup: {
                confirmText: "Ok",
                cancelText: "Annulla",
                deletePopup: { title: 'Elimina Ordine', message: 'Vuoi eliminare l\'ordine ' },
                returnPopup: {
                    title: 'Info',
                    message: 'Vuoi avviare la procedura di reso relativa all\'ordine n. ',
                    confirmText: 'Conferma',
                }
            },
            filters: {
                title: 'filtri',
                items: {
                    orderNum: "Numero ordine",
                    recipient: "Cliente"
                },
                button: "filtra",
            },
        }
    },
    OrdersReturned: {
        it: {
            title: 'resi',
            list: ["Numero Ordine Reso", "Data", "Vettore", "Cliente", "Numero Ordine", "Azioni", "Seleziona tutto"],
            listButtons: ['Scarica etichette'],
            messages: [
                { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
            ],
            popup: {
                confirmText: "Ok",
                cancelText: "Annulla",
                deletePopup: { title: 'Elimina Ordine', message: 'Vuoi eliminare l\'ordine ' },
                returnPopup: {
                    title: 'Info',
                    message: 'Vuoi avviare la procedura di reso relativa all\'ordine n. ',
                    confirmText: 'Conferma',
                }
            },
            filters: {
                title: 'filtri',
                items: {
                    orderNum: "Numero ordine",
                    recipient: "Cliente"
                },
                button: "filtra",
            },
        }
    },
    Bordero: {
        it: {
            title: 'lista borderò scaricabili',
            noSelectedBordero: "Nessun borderò selezionato.",
            filters: {
                items: {
                    orderNum: "Numero ordine",
                    dateFrom: "Data Da",
                    dateTo: "Data A",
                    warehouse: "Magazzino",
                    courier: "Corriere"/*,
                    search: "Cerca"*/
                },
                button: 'filtra'
            },
            list: ["Nome file", "Committente", "Magazzino", "Corriere", "Data", "Stato", "Seleziona tutto"],
            button: 'scarica borderò',
            messages: [
                { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }

            ],
            borderoDownloadedStatuses: ["Da scaricare", "Scaricato"]
        }
    },
    OrdersList: {
        it: {
            listTitle: 'lista ordini senza borderò',
            list: ["Numero Ordine", "Data", "Vettore", "Cliente", "Etichette", "Stato", "Stato Corriere", "Azione"],
            listButton: 'Scarica',
            listButtonDelete: 'Elimina',
            buttons: ['scarica etichette', 'invio al corriere', 'ricarica', 'invia tutti'],
            noReadyOrderSelected: "Nessun ordine pronto da stampare selezionato.",
            noSendableOrderSelected: "Nessun ordine da pronto inviare selezionato.",
            noOrderSelected: "Nessun ordine selezionato.",
            messages: [
                { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
            ],
            filters: {
                title: 'filtri',
                items: {
                    orderNum: "Numero ordine",
                    recipient: "Cliente",
                    labelState: "Stato etichetta"
                },
                button: "filtra",
            },
            labelDownloadedStatuses: ["Da scaricare", "Scaricata"]
        }
    },
    DiscardedOrdersList: {
        it: {
            listTitle: 'lista ordini scartati',
            list: ["Numero Ordine", "Data", "Vettore", "Cliente", "Motivazione", "Azione"],
            listButtons: ['Modifica', 'Elimina'],
            update: {
                title: 'modifica ordine scartato',
                inputs: ['nome', 'cognome', 'indirizzo', 'numero civico', 'nazione', 'città', 'provincia', 'cap', 'numero ordine', 'vettore', 'data', 'note ritiro'],
                button: 'invia ordine'
            },
            messages: [
                { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" },
                { captions: ["info"], messages: ['L\'ordine e\' stato inviato'], button: "Ok" }

            ],
            popup: {
                confirmText: "Ok",
                cancelText: "Annulla",
                deletePopup: { title: 'Gestione ordine scartato', message: 'Vuoi eliminare l\'ordine?' }
            },
            filters: {
                title: 'filtri',
                items: {
                    orderNum: "Numero ordine",
                    recipient: "Cliente"
                },
                button: "filtra",
            },
        }
    },
    UserProfile: {
        it: {
            card: {
                title: 'Le tue informazioni',
                logout: 'Log out',
                edit: 'Modifica i tuoi dati'
            },
            registration: {
                title: 'Dati di registrazione',
                name: 'nome',
                surname: 'cognome',
                phone: 'telefono',
                email: 'e-mail',
                userName: 'username',
                password: 'password',
                confirm: 'conferma password',
                chkAdmin: 'admin',
                chkUser: 'standard',
                chkReadonly: 'readonly',
                chkUserPro: 'utente pro',
                chkWarehouseAdmin: 'Admin Magazzino',
                chkWarehouseUser: 'Utente Magazzino',
                mandatoryMessage: 'I campi contrassegnati da asterisco (*) sono obbligatori'
            },
            invoicing: {
                title: 'Dati di fatturazione',
                name: 'nome',
                surname: 'cognome',
                phone: 'telefono',
                businessName: 'ragione sociale',
                certEmail: 'pec',
                // confirm: 'conferma pec',
                address: 'indirizzo e civico',
                city: 'città',
                vatNumber: 'partita iva',
                province: 'provincia',
                zipCode: 'cap',
                uniqueCode: 'codice univoco',
                fiscalCode: 'codice fiscale',
                adminEmail: 'email amministrativa',
                invoiceMessage: 'Per modificare i dati di fatturazione, contatta il tuo commerciale di riferimento',
            },
            buttons: ['Salva i tuoi dati', 'Annulla'],
            addUser: 'Aggiungi utente',

            mandatoryHint: 'I campi contrassegnati da asterisco (*) sono obbligatori',
            messages: [
                {
                    captions: ["errore"],
                    messages: [
                        'Campi della PEC non coincidenti.',
                        'Campi della password non coincidenti.',
                        'La password deve contenere da 12 a 64 caratteri, almeno una lettera maiuscola, una lettera minuscola, un numero e un carattere speciale.',
                        'Compilare tutti i campi obbligatori'
                    ],
                    button: "Ok"
                },
                {
                    captions: ["info"],
                    messages: ['Operazione eseguita con successo'],
                    button: "Ok"
                }
            ],
            usersList: {
                captions: ['Nome', 'Cognome', 'Nuova Password*', 'Conferma Password*', 'Telefono', 'Email', 'Profilo', 'Email di recupero', 'Azione'],
                buttonText: 'Lista Utenti',
                popup: {
                    title: 'Lista utenti',
                    cancelButton: 'Chiudi',
                    saveButton: 'Modifica',
                    deleteButton: 'Elimina'
                }
            },
            recoveryMail: {
                label: "E-mail di recupero",
                title: "Email di recupero",
                notConfigured: "Non configurata",
                pending: "In attesa di verifica",
                verified: "Verificata",
                currentAddress: "Indirizzo attuale:",
                pendingAddress: "In attesa di verifica:",
                save: "Salva email di recupero",
                remove: "Rimuovi email di recupero",
                invalidAddress: "Inserisci un indirizzo email valido.",
                loadError: "Impossibile caricare lo stato dell'email di recupero.",
                saveError: "Impossibile salvare l'email di recupero.",
                removeError: "Impossibile rimuovere l'email di recupero.",
                requestSent: "Email inviata. Controlla la casella indicata.",
                removed: "Email di recupero rimossa.",
                changeConfirmTitle: "Conferma email di recupero",
                removeConfirmTitle: "Rimuovi email di recupero",
                changeConfirmMessage: "Inserisci la password corrente per salvare il nuovo indirizzo.",
                removeConfirmMessage: "Inserisci la password corrente per confermare la rimozione."
            },
            passwordChange: {
                title: "Cambia password",
                newPassword: "Nuova password",
                confirmPassword: "Conferma nuova password",
                submit: "Cambia password",
                requirementsError: "La nuova password non rispetta i requisiti.",
                mismatchError: "La nuova password e la conferma non coincidono.",
                sameAsCurrentError: "La nuova password deve essere diversa dalla password attuale.",
                success: "Password modificata correttamente.",
                failure: "Impossibile modificare la password. Controlla la password corrente e riprova.",
                missingToken: "La password è stata modificata, ma non è stato ricevuto il nuovo token.",
                sessionUpdateError: "Impossibile aggiornare la sessione corrente.",
                confirmTitle: "Conferma cambio password",
                confirmMessage:"Inserisci la password corrente per confermare il cambio password.",
                sensitiveChangesTitle: "Conferma modifiche",
                sensitiveChangesMessage: "Inserisci la password corrente per confermare le modifiche."
            },
            passwordPolicy: {
                length: "Da 12 a 64 caratteri",
                uppercase: "Una lettera maiuscola",
                lowercase: "Una lettera minuscola",
                number: "Un numero",
                special: "Un carattere speciale",
                edgeSpaces: "La password contiene uno spazio iniziale o finale"
            }
        }
    },
    Couriers: {
        it: {
            couriers: {
                title: 'Aggiungi un nuovo corriere',
                info: ' ',
                search: 'Cerca',
                allCouriers: 'Tutti i corrieri'
            },
            details: { // IMPORTANT!! Do not use "carrierName" or "carrierId" keys here
                chkRules: 'usa regole sendabox',
                previousCourier: 'Seleziona regola da un corriere già inserito',
                account: 'CORRIERE ACCOUNT NUMBER',
                userId: 'CORRIERE USER ID',
                password: 'CORRIERE PASSWORD',
                accessKey: 'ACCESS KEY',
                labelType: 'Label type',
                chkA4: 'a4',
                chkPDF: 'pdf',
                chkZPL: 'zpl',
                btnCancel: 'annulla',
                btnOk: 'conferma'
            },
            list: {
                courier: 'Corriere',
                rules: 'Regole',
                status: 'Stato',
                title: 'corrieri',
                active: 'Attivo',
                inactive: 'Non attivo',
                editRules: 'Modifica',
                addRules: '+ Imposta regola per corrieri',
                columns: ['Corriere', 'Abilitato in Sendabox', 'Azioni'],
                buttons: ['Azione', 'Elimina', 'Regole']
            },
            rules: {
                buttons: [/*'imposta regole corrieri',*/ 'annulla', 'conferma'],
                title: 'regole nazionali',
                courier: 'CORRIERE',
                countersign: 'CONTRASSEGNO',
                region: 'Regione',
                package: 'Collo',
                packageMin: 'Min Colli',
                packageMax: 'Max Colli',
                minSize: 'Dimensione Min Collo',
                maxSize: 'Dimensione Max Collo',
                minWeight: 'Peso Min Collo',
                maxWeight: 'Peso Max Collo',
                minWeightTot: 'Peso Min Totale',
                maxWeightTot: 'Peso Max Totale',
                changeZip: 'Cap',
                zipTitle: 'cap regione ',
                zipColumns: ['PROVINCIA', 'CAP', 'SELEZIONA'],
                zipButtons: ['annulla', 'conferma'],
                countersignSel: ['Tutti', 'Con contrassegno', 'Senza contrassegno'],
                packageSel: ['Monocollo', 'Multicollo', 'Tutti'],
                ////packageMinSel: 1,
                packageMaxSel: 100,
                courierSel: ['Seleziona Corriere'],
                regionSel: ['Tutte le regioni'],
                capSel: ['Seleziona CAP'],
                province: 'Provincia',
                zipCode: 'Cap',
            },
            zips: {
                city: 'Città',
                vatNumber: 'Partita iva',
                province: 'Provincia',
                zipCode: 'Cap',
                uniqueCode: 'Codice univoco',
                fiscalCode: 'Codice fiscale',
                adminEmail: 'Email amministrativa'
            },
            popup: {
                confirmText: "Ok",
                cancelText: "Annulla",
                deletePopup: { title: 'Gestione Corriere', message: 'Vuoi eliminare il corriere?' }

            },
            messages: [
                { captions: ["errore"], messages: ['Configurazione del corriere mancante.'], button: "Ok" },
                { captions: ["info"], messages: ['Sono in uso le regole Sendabox.'], button: "Ok" },
                { captions: ["Modifica regola"], messages: ['Regola impostata'], button: "Ok" },
                { captions: ["Errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" }
            ],
            checkRuleResult: [
                "Il corriere {0} non può gestire la spedizione dell'ordine ",
                "- Regole non impostate",
                "- Numero colli",
                "- Dimensione collo",
                "- Peso collo",
                "- Peso totale",
                "- Non gestisce contrassegno",
                "- Gestisce solo con contrassegno",
                "- Destinazione fuori zona",
                "- Corriere non abilitato a spedire nel Paese selezionato",
                "- Non gestisce triangolazione"
            ]
        }
    },
    Marketplaces: {
        it: {
            marketplaces: {
                title: 'Aggiungi i tuoi store',
                info: 'Hai un tuo sito web personalizzato? Integralo attraverso le nostre API o contattaci.',
                allMarketplaces: 'Tutti i marketplace',
                search: 'Cerca'
            },
            details: {
                btnHelp: 'Istruzioni',
                btnCancel: 'annulla',
                btnOk: 'connetti %marketplace%',
                amazon: {
                    sellerNo: 'Numero venditore',
                    token: 'MWS AUTH TOKEN',
                    region: 'REGIONE',
                    chkBusinessOrders: 'Evidenzia gli Ordini Business',
                    chkPremiumOrders: 'Evidenzia gli Ordini Premium',
                    chkPrimeOrders: 'Evidenzia gli Ordini Prime',
                    chkLastDeliveryDate: "Mostra l'ultima Data di Consegna",
                    chkAutomaticUpdate: 'Aggiorna %marketplace% in automatico',

                },
                woocommerce: {
                    wooUrl: 'Url sito',
                    consumerKey: 'Consumer Key',
                    consumerSecret: 'Consumer Secret'


                },
                prestashop: {
                    prestaUrl: 'Url sito',
                    apiKey: 'Api Key',
                    idshop: 'Shop id(se multishop)',
                    paymentStateId: 'Payment state id (se id stato pagamento e\' stato modificato)'

                },
                magento1: {
                    magentoUrl: 'Url sito',
                    consumerKey: 'Consumer Key',
                    consumerSecret: 'Consumer Secret',
                    username: 'Username',
                    password: 'Password'

                },
                magento2: {
                    magentoUrl: 'Url sito',
                    consumerKey: 'Consumer Key',
                    consumerSecret: 'Consumer Secret',
                    accessToken: 'Access Token',
                    accessTokenSecret: 'Access Token Secret'

                },
                shopify: {
                    shopifyUrl: 'Url sito',
                    accessToken: 'Access Token'
                },
                ebay: {
                    url: 'Url sito',
                    clientId: 'Client id',
                    clientSecret: 'Client secret',
                    redirectUrl: 'Redirect url',
                    scope: 'Scope'
                }
            },
            list: {
                marketplace: 'Marketplace',
                status: 'Stato',
                active: 'Attivo',
                inactive: 'Non attivo',
                deleteTitle: 'Gestione Marketplace ?',
                deleteMessage: 'Cancellare il Marketplace ?',
                confirm: 'Conferma',
                cancel: 'Annulla'
                /*columns: //['Marketplace', 'Status', 'Azioni'],
                ['edit', 'delete', 'logo', 'azioni'],
                buttons: ['Modifica', 'Disabilita', 'Elimina']*/

            },
            messages: {
                error: { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                success: { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }


            }
        }
    },
    Countersigns: {
        it: {
            card: {
                title: 'totale spedizioni in contrassegno',
                entries: {
                    cashed: { text: 'Incassati', subText: 'contrassegni bonificati da Sendabox al cliente' },
                    cashIn: {
                        text: 'Da incassare', subText: 'contrassegni di spedizioni in transito/non andate a buon fine'
                    },
                    carrierCashed: { text: 'Incassati dal corriere', subText: 'contrassegni incassati dal corriere e ancora non bonificati a Sendabox' }
                }
            },
            filters: {
                title: 'filtra per',
                inputs: ['Data Da', 'Data A', 'Numero Ordine', 'Tutti gli esiti'],
                button: 'filtra'
            },
            list: {
                listTitle: 'tutti i contrassegni',
                captions: ["Data", "Numero Ordine", "Vettore", "Esito", "Azione"],
                listButton: 'Cambia esito',
                button: 'Scarica CSV'
            },
            modify: {
                title: 'cambia stato',
                description: 'Impostare il nuovo stato',
                button: 'conferma'
            },
            states: {
                cashed: "Incassato",
                cashIn: "Da incassare",
                returned: "Rientrato",
                working: "In lavorazione",
                carrierCashed: 'Incassato corriere'
            }
        }
    },
    Storaging: {
        it: {
            card: {
                title: 'totale giacenze gestite',
                entries: ['Giacenze']
            },
            list: {
                title: 'tutte le giacenze',
                captions: ["Data", "Numero Ordine", "Vettore", "Motivazione", "Azione"],
                listButton: 'Apri',
                button: 'Scarica CSV'
            },
            update: {
                title: 'Giacenza numero %goodsNo%',
                inputs: ['destinatario', 'corriere', 'numero di tracking', 'motivazione della giacenza'],
                //buttons: ['rientro giacenza', 'riprogramma consegna', 'modifica indirizzo']
                buttons: ['Rientro', 'Riconsegna', 'Indirizzo']
            },
            addressUpdate: {
                title: 'Modifica indirizzo ordine in giacenza',
                // inputs: ['nome', 'cognome', 'indirizzo', 'numero civico', 'città', 'provincia', 'cap', 'numero ordine', 'vettore', 'data', 'note ritiro'],
                inputs: ['nome', 'cognome', 'indirizzo', 'numero civico', 'nazione', 'città', 'provincia', 'cap', 'numero ordine', 'vettore', 'data', 'note ritiro'],
                button: 'invia ordine'
            },
            messages: {
                error: { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                success: { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
            },
            filters: {
                title: 'filtri',
                items: {
                    orderNum: "Numero ordine"
                },
                button: "filtra",
            },
        }
    },
    Tracking: {
        it: {
            dashboard: {
                title: "%par% spedizioni dal %par% al",
                message: "Per le spedizioni precedenti, si prega di controllare il tracking dalla pagina \"I tuoi ordini\"",
                bodyTitle: "consegnata",
                bodySubTitle: "%par% Spedizioni",
                dashFilterTitleFrom: "Dal",
                dashFilterTitleTo: "Al",
                items: {
                    delivered: { title: 'Consegnata', subTitle: '%par% Spedizioni' },
                    exceptions: { title: 'In Giacenza', subTitle: '%par% Spedizioni' },
                    delivering: { title: 'In Consegna', subTitle: '%par% Spedizioni' },
                    tentatives: { title: 'Reso al mittente', subTitle: '%par% Spedizioni' },
                    transit: { title: 'In Transito', subTitle: '%par% Spedizioni' },
                    sent: { title: 'Spedito', subTitle: '%par% Spedizioni' }
                }
            },
            filters: {
                title: 'filtri',
                allCarrier: 'Tutti i corrieri',
                items: {
                    orderNum: "Numero ordine",
                    carrier: "Corriere",
                    dateFrom: "A partire da",
                    recipient: "Destinatario",
                    barcode: "Barcode",
                    status: "Stato"
                },
                trackStatus: [
                    { text: "Tutti gli stati", value: "" },
                    { text: "Consegnato", value: "Consegnato" },
                    { text: "Spedito", value: "Spedito" },
                    { text: "In Consegna", value: "In Consegna" },
                    { text: "In Transito", value: "In Transito" },
                    { text: "In Giacenza", value: "In Giacenza" },
                    { text: "Reso al mittente", value: "Reso al mittente" },
                    { text: "Richiesta Di Ritiro", value: "Richiesta di ritiro" }
                ],
                button: "filtra"
            },
            captions: ["Ordine", "Destinatario", "Barcode", "Tracking", "Stato"],
            button: 'Scarica CSV',
            tracking: {
                title: 'Stato del tracking numero %par%'
            }
        }
    },
    Company: {
        it: {
            title: 'società',
            description: 'I dettagli della tua azienda verranno utilizzati nelle distinte di imballaggio, nelle pagine di tracciamento e nelle e-mail per i tuoi clienti.',
            sections: [
                {
                    id: 'company',
                    title: 'Info società',
                    inputs: [{ name: 'name', text: 'Nome società' }, { name: 'site', text: 'Sito web' }, { name: 'email', text: 'Indirizzo email' }]
                },
                {
                    id: 'socials',
                    title: 'Social media',
                    inputs: [{ name: 'twitter', text: 'Twitter' }, { name: 'facebook', text: 'Facebook' }, { name: 'instagram', text: 'Instagram' }]
                }

            ],
            messages: [
                { captions: ["errore"], messages: ['Si è verificato un errore.'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
            ],
            buttons: ['Salva']
        }
    },
    SenderAddresses: {
        it: {
            title: 'Indirizzi Mittente',
            description: 'Salva gli indirizzi che usi più spesso per accelerare il processo.',
            sections: [
                {
                    id: 'places',
                    title: 'Località',
                    action: '+ Aggiungi indirizzo',
                    edit: 'Modifica',
                    active: 'Attivo',
                    inactive: 'Non attivo'
                }
            ],
            message: {
                captions: ["Creazione address"],
                messages: [],
                button: "Ok",
                error: "Si e' verificato un errore...",
                addressesCreationError: "File errato o non contenente indirizzi.",
                addressesLoadingError: "Errore caricamento",
                addressesLoadingTitle: "Caricamento indirizzi",
                addressesFailsCsvBtn: "Scarica CSV Errori [*]",
                csvUploaded: {
                    captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok",
                    errors: { captions: ["errore"], messages: ['Si è verificato un errore.'], button: "Ok" },
                },
            },

            messages: [
                { captions: ["errore"], messages: ['Si è verificato un errore.'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
            ],
            buttons: ['aggiorna', 'Modifica', 'Elimina'],
            change: {
                title: ['nuovo indirizzo', 'modifica indirizzo'],
                inputs: ['nome/ragione sociale', 'cognome', 'indirizzo', 'numero civico', 'nazione', 'città', 'provincia', 'cap', 'email', 'telefono'],
                button: 'Salva',
                btnOk: 'Salva',
                btnCancel: 'Annulla'
            },
            fileTemplates: {
                title: "",
                transferTitle: "Template ordini",
                csv: ["carica csv", "scarica layout csv", "scarica istruzioni"]
            },
            popup: {
                confirmText: "Ok",
                cancelText: "Annulla",
                activeOrderModal: {
                    title: 'Info',
                    message: 'Vuoi avviare la procedura di reso relativa all\'ordine n. ',
                    confirmText: 'Ok',
                }
            }

        }
    },
    RecipientAddresses: {
        it: {
            title: 'Indirizzi Destinatario',
            description: 'Salva gli indirizzi che usi più spesso per accelerare il processo.',
            sections: [
                {
                    id: 'places',
                    title: 'Località',
                    action: '+ Aggiungi indirizzo',
                    edit: 'Modifica',
                    active: 'Attivo',
                    inactive: 'Non attivo'
                }
            ],
            message: {
                captions: ["Creazione address"],
                messages: [],
                button: "Ok",
                error: "Si e' verificato un errore...",
                addressesCreationError: "File errato o non contenente indirizzi.",
                addressesLoadingError: "Errore caricamento",
                addressesLoadingTitle: "Caricamento indirizzi",
                addressesFailsCsvBtn: "Scarica CSV Errori [*]",
                csvUploaded: {
                    captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok",
                    errors: { captions: ["errore"], messages: ['Si è verificato un errore.'], button: "Ok" },
                },
            },

            messages: [
                { captions: ["errore"], messages: ['Si è verificato un errore.'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
            ],
            buttons: ['aggiorna', 'Modifica', 'Elimina'],
            change: {
                title: ['nuovo indirizzo', 'modifica indirizzo'],
                inputs: ['nome/ragione sociale', 'cognome', 'indirizzo', 'numero civico', 'nazione', 'città', 'provincia', 'cap', 'email', 'telefono', 'Codice Dealer'],
                button: 'Salva',
                btnOk: 'Salva',
                btnCancel: 'Annulla'
            },
            fileTemplates: {
                title: "",
                transferTitle: "Template ordini",
                csv: ["carica csv", "scarica layout csv", "scarica istruzioni"]
            },


        }
    },
    Labels: {
        it: {
            title: 'Etichette',
            description: 'Configura i formati e le opzioni dell’etichetta.',
            sections: [
                {
                    id: 'labels',
                    title: 'Formato di etichetta predefinito', //'formati di etichette e fogli di imballaggio predefiniti',
                    items: [
                        { name: 'defaultLabel', text: 'Seleziona il formato' },
                        //{ name: 'additionalTextFirst', text: 'Testo aggiunitivo prima riga etichetta' },
                        //{ name: 'defaultPackingSlip', text: 'Foglio di imballaggio predefinito' },
                        //{ name: 'additionalTextSecond', text: 'Testo aggiunitivo seconda riga etichetta' }
                    ]
                }
            ],
            messages: [
                { captions: ["errore"], messages: ['Si è verificato un errore.'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
            ],
            buttons: ['Salva']
        }
    },
    PackageConfig: {
        it: {
            title: 'Collo',
            description: 'Configura il collo di default per ordini marketplace.',
            titles: ['Aggiungi collo', 'Modifica collo'],
            sections: [
                {
                    id: 'labels',
                    title: 'Aggiungi collo',
                    items: [
                        { name: 'name', text: 'Name' },
                        { name: 'length', text: 'Lunghezza(cm)' },
                        { name: 'height', text: 'Altezza(cm)' },
                        { name: 'depth', text: 'Profondità(cm)' },
                        { name: 'weight', text: 'Peso(kg)' }
                    ]
                }
            ],
            packageItems: [
                { name: 'length', text: 'Lung(cm)', longText: 'Lunghezza (cm)' },
                { name: 'height', text: 'Alt(cm)', longText: 'Altezza (cm)' },
                { name: 'depth', text: 'Prof(cm)', longText: 'Profondità (cm)' },
                { name: 'weight', text: 'Peso(kg)', longText: 'Peso (kg)' }
            ],
            packageControls: {
                default: 'Imposta come preferito',
                edit: 'Modifica',
                delete: 'Elimina'
            },
            messages: [
                { captions: ["errore"], messages: ['Si è verificato un errore.'], button: "Ok" },
                { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" },
                { captions: ["errore"], messages: ['Compilare correttamente le dimensioni'], button: "Ok" }
            ],
            buttons: ['Salva'],
            buttonText: "Aggiungi Collo"
        }
    },
    Notifications: {
        it: {
            //title: 'notifiche',
            //title: 'Tieni i tuoi clienti informati con le notifiche di spedizione.',
            sections: [
                {
                    id: 'emails',
                    description: 'Tieni i tuoi clienti informati con le notifiche di spedizione.',
                    title: 'Email di notifica',
                    status: 'Stato',
                    action: 'Invia e-mail di esempio all’indirizzo del mio account',
                    message: "L'invio automatico è ",
                    active: 'Attivo',
                    inactive: 'Non attivo',
                    //status: ['Attivo', 'Non attivo'],
                    edit: 'Cambia',
                    items: [
                        { name: 'package_sent', text: 'Email di conferma spedizione: informa i clienti quando il loro pacco è stato spedito.' },
                        { name: 'package_delivered', text: 'Email di conferma consegna: informa i clienti quando il loro pacco è stato consegnato.' }
                    ]
                }
            ],
            messages: {

                error: { title: ["errore"], icon: '', message: ['Si è verificato un errore.'], button: "Ok" },
                ok: { title: ["info"], icon: '', message: ['Operazione eseguita con successo'], button: "Ok" },
                mailInviata: { title: ["info"], icon: '', message: ['Mail inviata a '], button: "Ok" }
            },
            buttons: ['aggiorna']
        }
    },
    LabelStatusDescription: {
        it: {
            //field label
            completed: "Completata",
            ready: "Pronta",
            running: "In lavorazione",
            stock: "In giacenza",
            updating: "In aggiornamento",
            error: "Errore",
            generated: "Generata",
            todo: "In attesa",

            // field labelstatus
            downloaded: "Scaricata",
            notDownloaded: "Da scaricare",
        }
    },
    PickStatus: {
        it: {
            error: "In errore",
            sending: "In elaborazione",
            sent: "Ricevuto"
        }
    },
    CreditBox: {
        it: {
            title: 'Gestione crediti',
            credits: {
                label: 'CREDITI DISPONIBILI:',
                expiration: 'In scadenza:',
                total: 'Costo ordine',
                btn: 'Acquista Crediti'
            },
            summary: {
                title: 'Totale crediti',
                sub1: 'Disponibili',
                sub2: 'In scadenza',
                na: 'n/d'
            },
            products: {
                title: 'Acquista',
                cost: 'Costo',
                credits: 'crediti',
                payCDC: 'Paga con Carta di Credito'
            },
            messages: {

                error: { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "ok" },
                purchaseOk: {
                    captions: ["info"], messages: ['Acquisto completato'], button: "ok"
                },

            }

        }
    },
    Ebay: {
        it: {
            mustRenewToken: "E' necessario rinnovare l'utenticazione Ebay per permettere ai processi batch di aggiornare lo stato degli ordini.",
            ok: 'Elaborazione in corso...',
            authorizationErrorMsg: 'Errore di connessione a ebay'
        }
    },
    MonetaWebResult: {
        it: {
            ko: 'OOPS, C\'\E\' STATO UN ERRORE DURANTE L\'ACQUISTO DEI CREDIT-BOX',
            koMessage: 'Riprova controllando i dati inseriti, se il problema persiste contattare il servizio clienti',
            ok: 'L\'ACQUISTO DEI CREDIT-BOX E\' ANDATO A BUON FINE.',
            okMessage: 'A breve riceverai una mail di conferma'

        }

    },
    PayPal: {

        sendaboxId: 'Aakw6oTO5bYjVdpOk-IzBMPTgEudxK5zBHCtbwlnmpwaeiVvvTAGiXTPkZjn9PXHmeWApONPeD-x9adA',
        clientId: 'xxxxxxxx'
    },
    Warehouse: {
        SingleOrderCreation: {
            it: {
                title: "Crea ordine singolo per magazzino",
                configuration: "Configurazione",
                packageConfigTitle: "Configurazione Colli",
                courier: 'Corriere',
                orderNumLabel: 'Numero ordine',
                orderContentValueLabel: 'Valore merce',
                orderContentDescLabel: 'Contenuto',
                orderContentDescCheckLabel: 'Non sto spendendo articoli proibiti e sto utilizzando un imballaggio adeguato',
                orderTypes: {
                    title: 'Tipologia dell\' ordine',
                    inputs: ['Standard', 'Tech'],
                    value: ["STD", "TCH"]
                },
                package: {
                    addPackage: 'aggiungi colli',
                    removePackage: 'cancella',
                    title: 'pacco',
                    inputs: ['peso', 'lunghezza', 'altezza', 'profondità'],
                    units: ['Kg:', 'Cm:', 'Cm:', 'Cm:'],
                    packageOptionDefaultValue: "Seleziona anagrafica collo"
                },
                services: {
                    title: 'Servizi aggiuntivi',
                    service: [
                        { title: 'assicurazione', text: 'valore assicurato' },
                        { title: 'contrassegno', text: 'valore assicurato' },
                        { title: 'triangolazione', text: 'triangolazione' },
                        // { title: 'data di ritiro', text: 'scegli una data per il ritiro' }
                    ]
                },
                acceptance: 'Accetto le condizioni',
                acceptanceLink: {
                    link: 'https://www.sendabox.it/spedizioni-con-assicurazione.cshtml',
                    text: '(Leggi condizioni)'
                },
                triangulation: {
                    title: 'Triangolazione',
                    inputs: ['nome', 'cognome', 'presso nome o numero', 'indirizzo', 'numero civico', "nazione", 'città', 'provincia', 'cap', 'numero di cellulare', 'email', 'conferma email', 'note consegna']
                },
                stock: {
                    card: {
                        title: 'Stock',
                        entries: ['stock']
                    },
                    list: {
                        title: 'Stock',
                        captions: ["SKU", "Descrizione", "Quantità Disponibile", "Quantità Riservata", "Seriale", "Sales Order", "Bill to", "Ship to", "Owner Code", "Authority ID", "Nome Dealer", "Codice Dealer"],
                    },
                    messages: {
                        error: { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                        success: { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
                    },
                    filters: {
                        title: 'filtri',
                        items: {
                            SKU: "SKU Prodotto:",
                            description: "Descrizione",
                            serialCode: "Seriale",
                            dealerCode: "Dealer/Bill To",
                            SORD: "Sales Order",
                            DELN: "Delivery Name",
                            BCNU: "Bill to",
                            SCNU: "Ship to Number",
                            SCNA: "Ship to Name",
                            CNUM: "Authority ID",
                            QuantityFilter: "Q.tà",
                            filterButton: "FILTRA",
                            clearButton: "SVUOTA",
                        },
                        selectOperatorTitle: "Seleziona",
                        AdvancedFilterTitle: "Filtri Avanzati"
                    }
                },
                orderInfo: {
                    title: 'Informazioni Ordine',
                    referenceOrder: 'Riferimento ordine',
                    notAllowedCharacters: 'Caratteri non consentiti: \\ / : * ? " < > | e spazi',
                    notes: 'Note'

                },
                customerPickup: {
                    text: "Ritiro Cliente",
                },
                sender: {
                    title: 'Mittenza',
                    code: 'Codice Cliente',
                    inputs: ['Magazzino', 'Città', 'Provincia', 'Paese']
                },
                recipient: {
                    title: 'Destinatario',
                    code: 'Codice Destinatario',
                    inputs: ['Seleziona', 'Nome/Ragione sociale', 'Codice Dealer', 'Paese', 'Provincia', 'Città', 'CAP', 'Indirizzo', 'Email', 'Telefono'],
                    manualOption: "Inserimento manuale"
                },
                button: 'Crea ordine',
                warehouses: {
                    word: 'magazzino',
                    title: 'scegli magazzino per il pickup',
                    button: 'seleziona magazzino'
                },
                carrierCostModal: {
                    captions: ["Costo ordine corriere"],
                    message: ["Disponibili {0} Costo Ordine {1}.", "Vuoi continuare con la creazione dell'ordine?", " Il presente importo non è comprensivo dei costi relativi ad eventuali Servizi Accessori", "che potranno esservi addebitati in un momento successivo alla conclusione dell’ordine.", "Per la definizione di Servizi Accessori e dei relativi costi,", "si rimanda alle Condizioni Generali di Vendita di Sendabox pubblicate sul nostro sito"],
                    okText: "Accetto",
                    cancelText: "Annulla",

                },
                errors: {
                    referenceOrdersCharactersNotAllowed: "Il riferimento ordine contiene caratteri non consentiti o spazi",
                    nothingSelected: "Nessun elemento selezionato",
                    zeroQuantity: "La quantità deve essere maggiore di zero",
                    mandatoryQuantity: "Quantità obbligatoria",
                    numberInvalid: "Inserire un valore numerico per la quantità",
                    noDecimalQuantity: "La quantità non può essere decimale",
                    greaterThanMaxQuantity: "Quantità disponibile superata",
                    differentDealerCode: "Non è possibile selezionare prodotti con codici dealer diversi.",
                    RecipientDataError: "Controlla i dati del destinatario:",
                    differentDealerSelectionTooltip: "Questo prodotto non è selezionabile perché possiede un codice dealer diverso dai prodotti già selezionati",
                    genericError: "Qualcosa non ha funzionato",
                    duplicateOrderReference: "Esiste già un ordine con questo riferimento. Modifica il riferimento d'ordine e riprova per continuare.",
                },
                messages: [
                    { captions: ["errore"], messages: ['Si e\' verificato un errore'], button: "Ok" },
                    { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" },
                    { captions: ["errore"], messages: ['Compilare correttamente i campi evidenziati'], button: "Ok" },
                    {
                        captions: ["info"], messages: [
                            'Avvisiamo che per spedire nei Paesi Extra UE è necessario quanto segue.',
                            'Dotarsi di un codice EORI al fine di essere abilitati all’esportazione extra UE. Allegare alla spedizione:',
                            '- lettera di vettura debitamente compilata',
                            '- fattura commerciale o proforma contenente una descrizione dettagliata della merce spedita e la dichiarazione di libera esportazione'], button: "Ok"
                    },
                ],
                successPopup: {
                    title: "Invio Completato",
                    message: "L'orine: ",
                    messageSuffix: " è stato creato correttamente inviato"
                }
            }
        },
        Stock: {
            it: {
                card: {
                    title: 'Stock',
                    entries: ['stock']
                },
                list: {
                    title: 'Stock',
                    captions: ["SKU", "Descrizione", "Q.tà Disponibile", "Q.tà Riservata", "Seriale", "Sales Order", "Bill to", "Ship to", "Owner Code", "Authority ID", "Nome Dealer", "Codice Dealer"],
                    listButton: 'Info',
                    button: 'Scarica CSV'
                },
                info: {
                    title: 'Prodotto %SKU%',
                    inputs: ['SKU', 'Descrizione', 'Quantità Totale', 'Quantità Riservata', 'Quantità Disponibile', 'Seriale', 'Stato', 'Scadenza'],
                    buttons: ['Chiudi']
                },
                //addressUpdate: {
                //    title: 'Modifica indirizzo ordine in giacenza',
                //    // inputs: ['nome', 'cognome', 'indirizzo', 'numero civico', 'città', 'provincia', 'cap', 'numero ordine', 'vettore', 'data', 'note ritiro'],
                //    inputs: ['nome', 'cognome', 'indirizzo', 'numero civico', 'nazione', 'città', 'provincia', 'cap', 'numero ordine', 'vettore', 'data', 'note ritiro'],
                //    button: 'invia ordine'
                //},
                messages: {
                    error: { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                    success: { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
                },
                filters: {
                    title: 'filtri',
                    items: {
                        SKU: "SKU Prodotto:",
                        description: "descrizione",
                        serialCode: "Seriale",
                        dealerCode: "Dealer/Bill To:",
                        startWith: "Inizia con",
                        BCNU: "Bill to",
                        SORD: "Sales Order",
                        DELN: "Delivery Name",
                        SCNU: "Ship to Number",
                        SCNA: "Ship to Name",
                        CNUM: "Authority ID",
                        SSCC: "SSCC",
                        QuantityFilter: "Q.tà",
                        filterButton: "FILTRA",
                        clearButton: "SVUOTA",
                    },
                    selectOperatorTitle: "Seleziona",
                    AdvancedFilterTitle: "Filtri Avanzati"

                },
            }
        },
        OrderHistory: {
            it: {
                title: 'storico',
                list: ["Numero Ordine", "Data", "Riferimento Spedizione", "Cliente", "Codice Corriere", "Stato", "Codice Dealer", "Azioni"],
                listButtons: ['Scarica etichette', 'Reso', 'Elimina', 'Archivia'],
                messages: [
                    { captions: ["errore"], messages: ['Si e\' verificato un\'errore'], button: "Ok" },
                    { captions: ["info"], messages: ['Operazione eseguita con successo'], button: "Ok" }
                ],
                popup: {
                    confirmText: "Ok",
                    cancelText: "Annulla",
                    deletePopup: { title: 'Elimina Ordine', message: 'Vuoi eliminare l\'ordine ' },
                    archievePopup: { title: 'Archivia Ordine', message: 'L\'ordine verrà archiviato e non sarà più visibile, continuare?' },
                    returnPopup: {
                        title: 'Info',
                        message: 'Vuoi avviare la procedura di reso relativa all\'ordine n. ',
                        confirmText: 'Conferma',
                    }
                },
                filters: {
                    title: 'filtri',
                    items: {
                        number: "Numero ordine",
                        dealerCode: "Codice Dealer",
                        filterButton: "FILTRA",
                        clearButton: "SVUOTA",
                    },
                    button: "filtra",
                },
                errors: {
                    invalidOrder: "Ordine non valido",
                    cancelOrderError: "Errore durante l'annullamento dell'ordine",
                    orderDetailsError: "Errore durante il caricamento dei dettagli dell'ordine",
                    orderDetailsNotFound: "Dettagli dell'ordine non trovati"
                },
                confirmPopup: {
                    cancelOrderTitle: "Annullamento ordine",
                    cancelOrderConfirm: "Sei sicuro di voler annullare questo ordine?",
                    confirm: "Conferma",
                    cancel: "Annulla",
                    cancellingOrder: "Annullamento in corso..."
                },
                ResponsePopup: {
                    acceptedTitle: "Richiesta presa in carico",
                    acceptedMessage: "La richiesta di annullamento è stata presa in carico.",
                    rejectedTitle: "Richiesta rifiutata",
                    rejectedMessage: "La richiesta di annullamento è stata rifiutata.",
                    close: "Chiudi"
                }
            }
        },
        WarehouseAPIClient: {
            it: {
                error: {
                    somethingGoesWrong: "Qualcosa non ha funzionato",
                }
            }
        }
    },
    Components: {
        UISelectFieldTable: {
            it: {
                nothingSelected: "Nessun prodotto selezionato",
                selectedProduct: "Prodotti Selezionati:",
                select: "✓",
                quantity: "Quantità",
                actions: ["Azioni", "Rimuovi elemento"],
                pagination: ["Precedente", "Pagina", "di", "Successiva"],
                noData: "Nessun dato disponibile",
                showOnlyErrorsField: "Mostra solo errori",
                noErrorsField: "Nessun prodotto con errori",
                useFilterAdvice: "Usa i filtri e avvia una ricerca per visualizzare i prodotti disponibili.",
                unavailableProductTooltip: "",
            }
        },
        UITablePagination: {
            it: {
                elementsPerPage: "Elementi per pagina",
                pagination: ["di", "Mostra", "Pagina"],
                noResult: "Nessun risultato",
                noData: "Nessun dato disponibile"
            }
        },
        UITableWithPagination: {
            it: {
                noData: "Nessun dato disponibile",
                detailsColumn: "Dettagli",
                showDetails: "Mostra dettagli",
                hideDetails: "Nascondi dettagli"
            }
        },
        UIOrderDetails: {
            it: {
                title: "Prodotti ordinati",
                loading: "Caricamento prodotti...",
                empty: "Nessun prodotto disponibile",
                retry: "Riprova",
                productCount: "Numero di prodotti",
                sku: "SKU",
                description: "Descrizione",
                quantity: "Quantità",
                serial: "Seriale",
                notAvailable: "—",
                close: "Chiudi"
            }
        },
        UIAdvancedFilters: {
            it: {
                AdvancedFilterTitle: "Filtri Avanzati",
            }
        },
        CurrentPasswordPopup: {
            it: {
                defaultTitle: "Conferma operazione",
                defaultMessage: "Per proteggere il tuo account, inserisci la password corrente.",
                currentPassword: "Password corrente",
                requiredError: "Inserisci la password corrente.",
                cancel: "Annulla",
                confirm: "Conferma",
                confirming: "Conferma in corso..."
            }
        },
        PasswordSecurity: {
            it: {
                policyTitle: "La password deve contenere:",
                length: "Da 12 a 64 caratteri",
                uppercase: "Una lettera maiuscola",
                lowercase: "Una lettera minuscola",
                number: "Un numero",
                special: "Un carattere speciale",
                edgeSpaces: "La password contiene uno spazio iniziale o finale.",
                requirementPending: "Requisito da verificare",
                requirementInvalid: "Requisito non rispettato",
                requirementValid: "Requisito rispettato"
            }
        },
    },
    UnauthorizedPage: {
        it: {
            title: "Accesso non autorizzato",
            subtitle: "Non possiedi i permessi necessari per visualizzare questa pagina"
        }
    },
    ProtectedRoute: {
        it: {
            authorizationLoading: "Caricamento Autorizzazioni"
        }
    },
    Validate: {
        it: {
            required: " è obbligatorio",
            tooLong: " è troppo lungo",
            enterValidMail: "Inserire una mail valida"
        }
    }
};

